import { makeAutoObservable } from 'mobx';
import { Currency } from 'types';
import { codeToCurrency, currencyToCode, formatCurrency } from 'utils/helpers';
import { authorizedRequest } from '../utils/authorization';

interface Account {
  account: string;
  balance: number;
  balance_date: string;
  company_id: string;
  company_name: string;
  created: string;
  currency: '840' | '978';
  id: string;
  modified: string;
  type: 'counterparty-client' | 'bank';
}

class Accounts {
  constructor() {
    makeAutoObservable(this);
  }

  accounts: Account[] = [];

  isLoading = true;

  getAccounts = async (companyId: string) => {
    this.isLoading = true;
    try {
      const result = await authorizedRequest({
        service: 'transactions',
        url: `/v1/accounts/company-id/${companyId}`,
      });
      // Проверяем что результат является массивом
      this.accounts = Array.isArray(result) ? result : [];
    } catch (error) {
      console.error('Ошибка при загрузке аккаунтов:', error);
      // Устанавливаем пустой массив в случае ошибки
      this.accounts = [];
    } finally {
      this.isLoading = false;
    }
  };

  get getAccountBalance() {
    const result: { [key: string]: number } = {};
    // Добавляем проверку на существование массива accounts
    if (this.accounts && Array.isArray(this.accounts)) {
      this.accounts.forEach((account) => {
        if (account.type === 'counterparty-client') {
          result[String(codeToCurrency(account.currency))] = +account.balance;
        }
      });
    }
    return result;
  }
}

const accountsStore = new Accounts();
export default accountsStore;
